// Finans (Ödenek + Hakediş) detay kartları için ortak etiketler ve hesaplar
import { parseTL, toTLString, fmtTarih } from '../bakim-onarim/detayOrtak';

export { parseTL, toTLString, fmtTarih };

export const TALEP_YERI_TR = { yigm: 'YİGM', spor_toto: 'SPOR TOTO', strateji: 'STRATEJİ' };
export const ODENEK_TURU_TR = { taahhut: 'TAAHHÜT', protokol: 'PROTOKOL', ek_taahhut: 'EK TAAHHÜT', ek_protokol: 'EK PROTOKOL' };
export const DURUM_TR = { geldi: 'GELDİ', gelmedi: 'GELMEDİ', geldi_odendi: 'GELDİ-ÖDENDİ', odenmedi: 'ÖDENMEDİ', iptal_edildi: 'İPTAL EDİLDİ', iptal: 'İPTAL' };
export const IHALE_ONAYI_TR = { geldi: 'Geldi', gelmedi: 'Gelmedi' };

export const DURUM_TONE = {
  geldi: 'bg-emerald-500/20 text-emerald-300 border-emerald-500/50',
  geldi_odendi: 'bg-blue-500/20 text-blue-300 border-blue-500/50',
  gelmedi: 'bg-amber-500/20 text-amber-300 border-amber-500/50',
  odenmedi: 'bg-amber-500/20 text-amber-300 border-amber-500/50',
  iptal_edildi: 'bg-red-500/20 text-red-300 border-red-500/50',
  iptal: 'bg-red-500/20 text-red-300 border-red-500/50',
};

const up = (v) => String(v || '').toLocaleUpperCase('tr');
export const talepYeriLabel = (v) => TALEP_YERI_TR[v] || up(v);
export const odenekTuruLabel = (v) => ODENEK_TURU_TR[v] || up(v);
export const durumLabel = (v) => DURUM_TR[v] || up(v);
export const ihaleOnayiLabel = (v) => IHALE_ONAYI_TR[v] || v || '';

// Ek taahhüt/protokol satırları: yeni liste yapısı yoksa eski tekil alanlara düşer
export const ekSatirlar = (od, tip) => {
  const liste = tip === 'taahhut' ? od?.ek_taahhutler : od?.ek_protokoller;
  if (Array.isArray(liste) && liste.length) return liste.map(x => ({ talep_yeri: x.talep_yeri || od.talep_yeri, tarih: x.tarih, yazisi: x.yazisi, tutari: x.tutari, durumu: x.durumu }));
  const pre = tip === 'taahhut' ? 'ek_taahhut' : 'ek_protokol';
  if (od?.[`${pre}_talep_tutari`] || od?.[`${pre}_talep_tarihi`]) {
    return [{ talep_yeri: od.talep_yeri, tarih: od[`${pre}_talep_tarihi`], yazisi: od[`${pre}_talep_yazisi`], tutari: od[`${pre}_talep_tutari`], durumu: od[`${pre}_odenek_durumu`] }];
  }
  return [];
};

// Ana talep + tüm ek satırların toplamı (iptal edilenler hariç)
export const toplamOdenek = (od) => (od?.odenek_durumu === 'iptal_edildi' ? 0 : parseTL(od?.talep_tutari))
  + [...ekSatirlar(od, 'taahhut'), ...ekSatirlar(od, 'protokol')].filter(x => x.durumu !== 'iptal_edildi').reduce((s, x) => s + parseTL(x.tutari), 0);

export const toplamHakedis = (hakedisler) => (hakedisler || []).reduce((s, h) => s + parseTL(h.talep_tutari), 0);

export const yuzde = (pay, toplam) => (toplam > 0 ? `${((pay / toplam) * 100).toFixed(1).replace('.', ',')} %` : '');
